import { Download, HelpCircle } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger,
} from "@/components/ui/dialog";
import { CSV_IMPORT_HELP, columnasCsvEjemplo, descargarPlantillaEmpleadosCsv } from "@/lib/importarEmpleadosCsv";

function BotonPlantilla({ className = "", variant = "outline", size = "sm" }) {
  const descargar = async () => {
    try {
      await descargarPlantillaEmpleadosCsv(api);
      toast.success("Plantilla descargada");
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };
  return (
    <Button type="button" variant={variant} size={size} className={`gap-1.5 ${className}`} onClick={descargar} data-testid="descargar-plantilla-csv-btn">
      <Download className="h-4 w-4" />
      Descargar plantilla CSV
    </Button>
  );
}

function AyudaContenido({ mostrarBotonPlantilla = true }) {
  return (
    <div className="space-y-4 text-sm text-zinc-600">
      <p>{CSV_IMPORT_HELP.intro}</p>
      <p className="text-xs text-zinc-500">{CSV_IMPORT_HELP.separador}</p>

      {mostrarBotonPlantilla && (
        <BotonPlantilla className="w-full border-violet-200 text-violet-900 hover:bg-violet-50" />
      )}

      {CSV_IMPORT_HELP.grupos.map((grupo) => (
        <div key={grupo.titulo} className="rounded-lg border border-violet-100 bg-violet-50/50 px-3 py-2">
          <p className="font-semibold text-zinc-800">{grupo.titulo}</p>
          <p className="mt-1 font-mono text-xs leading-relaxed text-zinc-700">{grupo.columnas.join("; ")}</p>
          {grupo.nota && <p className="mt-1.5 text-xs text-zinc-500">{grupo.nota}</p>}
        </div>
      ))}

      <div className="rounded-lg border border-zinc-200 bg-zinc-50 px-3 py-2">
        <p className="text-xs font-semibold text-zinc-700">Ejemplo de cabecera</p>
        <p className="mt-1 break-all font-mono text-[11px] leading-relaxed text-zinc-600">{columnasCsvEjemplo()}</p>
      </div>

      <p className="text-xs text-zinc-500">{CSV_IMPORT_HELP.noImportables}</p>
    </div>
  );
}

export function ImportarEmpleadosAyudaDialog({ triggerClassName = "" }) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button
          type="button"
          variant="outline"
          size="sm"
          className={`gap-1.5 border-white/40 bg-white/10 text-white hover:bg-white/20 hover:text-white ${triggerClassName}`}
          data-testid="importar-csv-ayuda-btn"
        >
          <HelpCircle className="h-4 w-4" />
          Ayuda
        </Button>
      </DialogTrigger>
      <DialogContent className="max-h-[90vh] max-w-lg overflow-y-auto" data-testid="importar-csv-ayuda-dialog">
        <DialogHeader>
          <DialogTitle>Ayuda importación CSV</DialogTitle>
          <DialogDescription>Columnas admitidas, plantilla y reglas de importación de empleados.</DialogDescription>
        </DialogHeader>
        <AyudaContenido />
      </DialogContent>
    </Dialog>
  );
}

export function ImportarEmpleadosAyudaInline({ mostrarBotonPlantilla = true }) {
  return <AyudaContenido mostrarBotonPlantilla={mostrarBotonPlantilla} />;
}

export { BotonPlantilla as DescargarPlantillaEmpleadosCsv };
